import axiosInstance from './axiosInstance';

export interface TurnoResponse {
  id: string;
  pacienteId: string;
  pacienteNombre: string;
  pacienteApellido: string;
  pacienteDni: string;
  fecha: string;
  hora: string;
}

export interface TurnoRequest {
  pacienteId: string;
  fecha: string;
  hora: string;
}

export interface ActualizarTurnoRequest {
  fecha: string;
  hora: string;
}

export async function listarTurnos(fecha?: string): Promise<TurnoResponse[]> {
  const response = await axiosInstance.get<TurnoResponse[]>('/api/turnos', {
    params: fecha ? { fecha } : undefined,
  });
  return response.data;
}

export async function crearTurno(data: TurnoRequest): Promise<TurnoResponse> {
  const response = await axiosInstance.post<TurnoResponse>('/api/turnos', data);
  return response.data;
}

export async function actualizarTurno(id: string, data: ActualizarTurnoRequest): Promise<TurnoResponse> {
  const response = await axiosInstance.put<TurnoResponse>(`/api/turnos/${id}`, data);
  return response.data;
}

export async function eliminarTurno(id: string): Promise<void> {
  await axiosInstance.delete(`/api/turnos/${id}`);
}
